var React = require('react');

function ThumbsDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 0.0174866H5C4.17 0.0174866 3.46 0.517486 3.16 1.23749L0.14 8.28749C0.05 8.51749 0 8.75749 0 9.01749V11.0175C0 12.1175 0.9 13.0175 2 13.0175H8.31L7.36 17.5875L7.33 17.9075C7.33 18.3175 7.5 18.6975 7.77 18.9675L8.83 20.0175L15.41 13.4275C15.78 13.0675 16 12.5675 16 12.0175V2.01749C16 0.917487 15.1 0.0174866 14 0.0174866ZM14 12.0175L9.66 16.3575L10.77 11.0175H2V9.01749L5 2.01749H14V12.0175ZM18 0.0174866H22V12.0175H18V0.0174866Z","fill":"#373a36"}));
}

ThumbsDown.defaultProps = {"width":"22","height":"21","viewBox":"0 0 22 21","fill":"none"};

module.exports = ThumbsDown;

ThumbsDown.default = ThumbsDown;
